<field-select name="arrivalPortId" options="ports" col="6 12"></field-select>
<field-select name="departurePortId" options="ports" col="6 12"></field-select>
<field-text name="breadth" format="length" col="6 12"></field-text>
<field-text name="speed" format="speed" col="6 12"></field-text>
<field-text name="speedTolerance" format="speed" col="6 12"></field-text>
